import React from 'react';
import { FormProps, FormInstance } from '@oscar/theme';
import { FormOptions } from './typed';
import useOptionsForm from './hooks/useOptionsForm';
import Form from './components/Form';
import { correctFormName } from './utils';

export default function withForm<T = {}>(options: FormOptions) {
  return (WrapComponent: React.ComponentType<T>) => {
    const ComplexForm: React.ForwardRefRenderFunction<
      FormInstance,
      FormProps & T
    > = (props) => {
      const { form: wrapForm, ...remain } = props;

      const [hookForm] = useOptionsForm(options, wrapForm, remain);

      return (
        <Form
          options={{ ...options, name: correctFormName(options.name) }}
          form={hookForm}
          size={options.size}
        >
          <WrapComponent {...(remain as T)} />
        </Form>
      );
    };

    return ComplexForm;
  };
}
